var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_vm.fetching ? _c('p', [_vm._v("Loading...")]) : [_c('div', {
    staticClass: "s-mb-6 s-space-y-3 text-center"
  }, [_c('Status', {
    staticClass: "s-text-secondary",
    attrs: {
      "icon": "check",
      "message": "您已完成下單"
    }
  }), _c('p', [_vm._v("感謝您的關注")])], 1), _c('DescriptionList', {
    staticClass: "s-mb-8",
    attrs: {
      "title": "商品名稱"
    }
  }, [_vm._v(_vm._s(_vm.product.title))]), _c('div', {
    staticClass: "s-space-y-8 s-pb-8 s-mb-5 s-border-b s-border-gray-lighter"
  }, [_c('div', {
    staticClass: "s-flex"
  }, [_c('DescriptionList', {
    staticClass: "s-flex-1",
    attrs: {
      "title": "款式"
    }
  }, [_vm._v(_vm._s(_vm.spec.sku_name))]), _c('DescriptionList', {
    staticClass: "s-flex-1",
    attrs: {
      "title": "購買數量"
    }
  }, [_vm._v(_vm._s(_vm.data.quantity) + " 組")])], 1), _c('DescriptionList', {
    attrs: {
      "title": "下單金額"
    }
  }, [_vm._v(_vm._s(_vm.$currency(_vm.data.total_price)))]), _c('div', {
    staticClass: "s-flex"
  }, [_c('DescriptionList', {
    staticClass: "s-flex-1",
    attrs: {
      "title": "團購 ID"
    }
  }, [_vm._v(_vm._s(_vm.groupBuying.groupbuying_number))]), _c('DescriptionList', {
    staticClass: "s-flex-1",
    attrs: {
      "title": "訂單 ID"
    }
  }, [_vm._v(_vm._s(_vm.data.order_number))])], 1)], 1), _vm.statusCategory !== _vm.STATUS_GOING ? [_c('p', {
    staticClass: "s-mb-5 s-text-secondary"
  }, [_vm._v("↓ 請持續關注 LINE 確認此團進度")]), _c('a', {
    staticClass: "s-btn s-btn-secondary",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("前往 LINE 帳號")])] : [_c('a', {
    staticClass: "s-btn s-btn-primary s-mb-4",
    attrs: {
      "href": "".concat(_vm.apiBaseURL, "/goto-ec/").concat(_vm.data.id)
    }
  }, [_vm._v(" 前往付款 ")]), _c('router-link', {
    staticClass: "s-btn s-btn-secondary s-mb-8",
    attrs: {
      "to": {
        name: 'LiffGroupBuyingShow',
        params: {
          id: _vm.groupBuying.id
        },
        query: {
          modify: null
        }
      }
    }
  }, [_vm._v(" 編輯下單數量 ")]), _c('p', {
    staticClass: "s-text-center"
  }, [_c('a', {
    staticClass: "s-link s-link-secondary",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function click($event) {
        $event.preventDefault();
        return _vm.$refs.confirm.open();
      }
    }
  }, [_vm._v(" 取消下單 ")])]), _c('Modal', {
    ref: "confirm",
    attrs: {
      "title": "您是否要取消訂單？"
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function fn(_ref) {
        var close = _ref.close;
        return [_c('div', {
          staticClass: "s-flex s-space-x-3"
        }, [_c('button', {
          staticClass: "s-btn s-btn-secondary",
          attrs: {
            "type": "button"
          },
          on: {
            "click": _vm.cancelOrder
          }
        }, [_vm._v("取消訂單")]), _c('button', {
          staticClass: "s-btn s-btn-primary",
          attrs: {
            "type": "button"
          },
          on: {
            "click": close
          }
        }, [_vm._v("保留訂單")])])];
      }
    }])
  }, [_vm._v(" 您是否要取消訂單？ ")])]]], 2);
}
var staticRenderFns = []

export { render, staticRenderFns }